import * as React from 'react';
/**
 *
 * Original name: compass
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=14780%3A9527
 *
 */
export const CompassLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m14.025 14.025 1.519-5.569-5.57 1.519-1.518 5.569 5.569-1.519ZM13 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20c-5.383 0-8-2.617-8-8s2.617-8 8-8 8 2.617 8 8-2.617 8-8 8Zm0-1.5c-2.471 0-4.017-.6-4.958-1.542C6.1 16.017 5.5 14.471 5.5 12s.6-4.017 1.542-4.958C7.983 6.1 9.529 5.5 12 5.5s4.017.6 4.958 1.542C17.9 7.983 18.5 9.529 18.5 12s-.6 4.017-1.542 4.958C16.017 17.9 14.471 18.5 12 18.5Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
